var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vpn-download"},[_c('HeadNav'),_vm._v(" "),_c('main',{staticClass:"vpn-download__main"},[_c('DownloadHeroSection'),_vm._v(" "),_c('div',{staticClass:"vpn-download__body"},[_c('ApkSafetySection'),_vm._v(" "),_c('SetupSection'),_vm._v(" "),_c('DownloadNoticeSection')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }